module.exports = __webpack_public_path__ + "static/media/Ambipom_gaussian2.626af575.png";